import { render, staticRenderFns } from "./GraveTextData.vue?vue&type=template&id=458182fa"
import script from "./GraveTextData.vue?vue&type=script&lang=js"
export * from "./GraveTextData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports